export function formatFloat(value, minimumFractionDigits = 2, maximumFractionDigits = 2) {
  return Intl.NumberFormat('fr', {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
}
